
export default function(instance) {
    return {
        getFaqPage() {
            return instance.get('/public/faq', {});
        },
    };
}